import { useSelector } from "react-redux";
import { RootState } from "../../../../../redux/store";
import { ListingType } from "../../../../../enums/listing/TitleTypes";
import { ListingModalOptionProvider } from "./ListingModalOptionProvider";
import { ListingModalBronzeOption } from "./ListingModalBronzeOption";
import { ListingModalSilverOption } from "./ListingModalSilverOption";
import { ListingModalGoldOption } from "./ListingModalGoldOption";
import { ListingModalOneTimeOption } from "./ListingModalOneTimeOption";
import { SecondaryButton } from "../../../../global/buttons/material/secondaryButton/SecondaryButton";
import { Check } from "@mui/icons-material";
import { useOnetimeBuyVerifyPurchase } from "../../../../../hooks/trainingPlan";

export const ListingModalContent = () => {
  const listingType = useSelector(
    (state: RootState) => state.trainingPlan.listingType,
  );
  const listingData = useSelector(
    (state: RootState) => state.trainingPlan.listingData,
  );
  const listingTypeIsAssessment = listingType === ListingType.ASSESSMENT;
  const isPurchased = useOnetimeBuyVerifyPurchase({
    currentListing: listingData,
  });

  if (!listingTypeIsAssessment && !listingData.hidden) {
    return (
      <>
        {isPurchased && (
          <SecondaryButton startIcon={<Check />} title="In your library" />
        )}
        <ListingModalOptionProvider>
          <ListingModalBronzeOption />
        </ListingModalOptionProvider>

        <ListingModalOptionProvider>
          <ListingModalSilverOption />
        </ListingModalOptionProvider>

        <ListingModalOptionProvider>
          <ListingModalGoldOption />
        </ListingModalOptionProvider>

        <ListingModalOptionProvider>
          <ListingModalOneTimeOption
            disabled={isPurchased}
            useSecondaryButton={listingData.price !== 0}
          />
        </ListingModalOptionProvider>
      </>
    );
  }

  if (listingTypeIsAssessment || listingData.hidden) {
    return (
      <ListingModalOptionProvider>
        {isPurchased && (
          <SecondaryButton startIcon={<Check />} title="In your library" />
        )}
        <ListingModalOneTimeOption
          disabled={isPurchased}
          useSecondaryButton={listingData.price !== 0}
        />
      </ListingModalOptionProvider>
    );
  }
};
